import type { RootState } from '~publish/legacy/store'

export const showInstagramNotificationsPreview = (state: RootState): boolean =>
  state?.reminders?.showInstagramNotificationsPreview
